<template>
  <div class="s-net-price">
    <div class="s-net-price__conts">
      <div class="s-net-price__main">
        <div class="s-net-price__aside">{{ title }}</div>
        <div class="s-net-price__cont">
          <div class="b-icon-tabs">
            <LottieTabs
              :lottie-tabs="lottieTabs"
              @changed-tab="getSelectedTab"></LottieTabs>

            <div v-if="lottieTab === 'table'" class="s-net-price__data">
              <div class="s-net-price__data__table">
                <NetPriceTable :data="tableData"></NetPriceTable>
              </div>

           
              <div class="s-net-price__data__accordion">
                <div class="s-net-price__accordion">
                  <div
                    v-for="(item, i) in tableData.data"
                    :key="i"
                    v-auto-animate>
                    <NetPriceAccordion :item="item"></NetPriceAccordion>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="lottieTab === 'chart'" class="s-net-price__data">
              <Loader v-if="isLoading" display="absolute"></Loader>
              <Alert
                v-if="errorMsgs.length"
                type="danger"
                :messages="errorMsgs" />

              <line-chart
                v-if="chartData"
                :labels="chartData.labels"
                :datasets="chartData.datasets"
                :type="type"
                :pdf="chartData.pdf"
                :graph-update-counter="graphUpdateCounter"></line-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Loader from '../common/Loader.vue'
import Alert from '../common/Alert.vue'
import LottieTabs from './LottieTabs.vue'
import NetPriceTable from './NetPriceTable.vue'
import NetPriceAccordion from './NetPriceAccordion.vue'

import LineChart from '../charts/line-chart.vue'

export default {
  components: {
    Loader,
    Alert,
    LottieTabs,
    NetPriceTable,
    LineChart,
    NetPriceAccordion,
  },
  props: {
    title: {
      default: '',
      type: String,
    },
    lottieTabs: {
      default: null,
      type: Array,
    },
    tableData: {
      default: null,
      type: Object,
    },
    chartHandler: {
      default: '',
      type: String,
    },
    tabId: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      lottieTab: '',
      isLoading: false,
      errorMsgs: [],
      chartData: null,
      type: '',
      graphUpdateCounter: 0,
    }
  },
  mounted() {
    
  },
  methods: {
    getSelectedTab(tab) {
      this.lottieTab = tab

      if (this.lottieTab === 'chart') {     
        this.fetchLineData()
      }
    },

    fetchLineData() {
      this.isLoading = true

      const payload = {
        tabId: this.tabId    
      }

      axios
        .post(this.chartHandler, payload)
        .then((response) => {
          const { hasError, errorMessages, data, type } = response.data

          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }

          this.isLoading = false
          this.chartData = data
          this.type = type
          this.graphUpdateCounter += this.graphUpdateCounter         
        })
        .catch((errors) => {
          console.error(errors)
        })
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },
  },
}
</script>
